// extracted by mini-css-extract-plugin
export default {"panel":"ImportantNow_panel__v8JjV","title":"ImportantNow_title__nRX14"};